import { Controller } from "@hotwired/stimulus"

// Doctor card: when a doctor practises at multiple hospitals, the <select> switches the
// visible practice-location panel (schedule/booking) and updates the header fee + address.
export default class extends Controller {
  static targets = ["select", "panel", "fee", "feeWrap", "address", "profileLink"]

  // On a paid (contracted) card the whole tile is a modal trigger; keep clicks on the
  // hospital <select> from bubbling up and opening the appointment modal.
  stopClick(event) {
    event.stopPropagation()
  }

  switch() {
    const opt = this.selectTarget.selectedOptions[0]
    if (!opt) return
    const hid = opt.value

    this.panelTargets.forEach((panel) => {
      const match = panel.dataset.hospitalId === hid
      panel.classList.toggle("hidden", !match)
      panel.classList.toggle("flex", match)
    })

    // Keep the profile links pointing at the selected hospital (?hospital=slug) so the
    // doctor profile opens pre-selected to it.
    const slug = opt.dataset.slug
    if (slug) {
      this.profileLinkTargets.forEach((a) => {
        try {
          const url = new URL(a.href, window.location.origin)
          url.searchParams.set("hospital", slug)
          a.href = url.pathname + url.search
        } catch (e) { /* ignore malformed href */ }
      })
    }

    // Fee: hide the whole line when the selected hospital has no fee (empty data-fee).
    const fee = opt.dataset.fee || ""
    if (this.hasFeeTarget) this.feeTarget.textContent = fee
    if (this.hasFeeWrapTarget) this.feeWrapTarget.classList.toggle("hidden", !fee)

    if (this.hasAddressTarget && opt.dataset.address) this.addressTarget.textContent = opt.dataset.address
  }
}
